<div class="h-100">
  <!-- Nouveau commentaire -->
  <div #header class="history-row position-relative">
    <img *ngIf="LogoCollaboConnected" class="rounded-circle position-absolute d-none d-lg-inline" style="top: 0;" [src]="getUrl(LogoCollaboConnected)" alt="">
    <p class="text-center w-100"><img *ngIf="LogoCollaboConnected" class="rounded-circle d-lg-none d-inline py-2" style="height:100% !important" [src]="getUrl(LogoCollaboConnected)" alt=""></p>
    <q-avatar *ngIf="!LogoCollaboConnected"
              class="col-auto align-self-center position-absolute"
              style="top: 0;"
              [name]="NameCollaboConnected"
              size="35"></q-avatar>
    <div class="col mx-lg-3 mx-0 p-0 q-input-no-border marginCombo">
      <textarea [(ngModel)]="HistoryNewComment"
                [ngClass]="[emptyComment ? 'q-danger' : '']"
                class="q-input-no-border noscrollbars pl-2 heightArea"
                (blur)="emptyComment = false;"
                (keyup)="TexteareaAutoGrow($event);" rows="1" placeholder="Ecrire un commentaire"></textarea>
      <select class="q-main-select m-2 widthSelect" [(ngModel)]="HistoryBoTypeValue" required>
        <option *ngFor="let type of HistoryBoTypes" [value]="type.id">{{type.value}}</option>
      </select>
      <select class="q-main-select m-2 widthSelect" [(ngModel)]="idContact" *ngIf="type === 'STAGE'" required>
        <option value="0">Sélectionnez un stagiaire</option>
        <option *ngFor="let contact of ListContacts" [value]="contact.id">{{contact.value}}</option>
      </select>
      <button [disabled]="!HistoryNewComment" class="m-2 px-4 col-auto q-btn q-main widthButton" (click)="SaveComment()">Enregistrer</button>
    </div>
  </div>

  <!-- Historique -->
  <ng-container *ngIf="historyService.ListHistories && historyService.ListHistories.length > 0">
    <div class="col text-center" *ngIf="historyService.IsLoading"><i class="fas fa-spin fa-spinner fa-pulse q-c-main fa-5x"></i></div>
    <div class="w-100" *ngIf="!historyService.IsLoading">
      <ng-container *ngFor="let history of historyService.ListHistories">
        <ng-container [ngSwitch]="history.ModeHisto">

          <div class="history-row mt-2 mt-sm-2 position-relative">
            <img *ngIf="history && history.Person && history.Person.ProfilePicture" class="d-none d-lg-inline rounded-circle position-absolute" style="top: 0;" [src]="getUrl(history.Person.ProfilePicture)" alt="">
            <p class="w-100"><img *ngIf="history && history.Person && history.Person.ProfilePicture" class="d-lg-none d-inline rounded-circle" [src]="getUrl(history.Person.ProfilePicture)" alt=""></p>
            <q-avatar *ngIf="(!history || !history.Person || !history.Person.ProfilePicture) && (history && history.Person && history.Person.value)"
                      class="col-auto align-self-center position-absolute"
                      style="top: 0;"
                      [name]="history.Person.value"
                      size="35">
            </q-avatar>

            <!--Mode générique-->
            <ng-container *ngSwitchCase="HistoryMode.INFO">
              <div class="col mx-3 p-0 marginDiv">
                <div>
                  <p class="history-row history-date">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</p>
                  <span class="history-person">{{history.Person.value}} : </span>
                  <!--<span class="font-size-13">génération devis </span>-->
                  <span class="invoice-name">{{history.Value}}</span>
                </div>
                <div class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="!history.ReadOnly" class="col-12 mx-lg-3 m-0 p-0 marginDiv">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

            <!--Mode envoi de mail-->
            <ng-container *ngSwitchCase="HistoryMode.SENDMAIL">
              <div class="col mx-3 p-0" style="margin-left: 40px !important;">
                <div>
                  <p class="history-row history-date">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</p>
                  <div class="row q-pointer" (click)="openHistoModal(history)">
                    <span><i class="fas fa-envelope"></i></span>
                    <span class="history-person"> {{history.Person.value}} </span>
                  </div>
                  <div class="row">
                    <span class="q-text-m" [innerHTML]="history.Value"></span>
                  </div>
                  <div class="row mb-2" *ngIf="history.EtatHisto">
                    <span class="q-bold q-text-m">Etat: </span><span class="q-text-m">{{history.EtatHisto}}</span>
                  </div>
                </div>
                <div class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="!history.ReadOnly" class="col-12 mx-3 p-0" style="margin-left: 40px !important;">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>
            <!--Mode création-->
            <ng-container *ngSwitchCase="HistoryMode.CREATE">
              <div class="col mx-3 p-0" style="margin-left: 40px !important;">
                <div>
                  <p class="history-row history-date">
                    {{
history.Date | NumberOfQueovalDay
                    }} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}
                  </p>
                  <span class="history-person">{{history.Person.value}} </span>
                  <span class="column-name">{{history.Value}}</span>
                </div>
                <div class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="!history.ReadOnly" class="col-12 mx-3 p-0" style="margin-left: 40px !important;">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

            <!--Mode modification (même que création pour le moment)-->
            <ng-container *ngSwitchCase="HistoryMode.UPDATE">
              <div class="col mx-3 p-0" style="margin-left: 40px !important;">
                <div>
                  <p class="history-row history-date">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</p>
                  <span class="history-person">{{history.Person.value}} </span>
                  <span class="column-name">{{history.Value}}</span>
                </div>
                <div class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="!history.ReadOnly" class="col-12 mx-3 p-0" style="margin-left: 40px !important;">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

            <!--Mode gagné -->
            <ng-container *ngSwitchCase="HistoryMode.WIN">
              <div class="col mx-3 p-0 q-input-no-border box-rounded q-success" style="margin-left: 40px !important;">
                <div class="m-1">
                  <p class="history-row history-date">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</p>
                  <span class="history-person">{{history.Person.value}} </span>
                  <span class="font-size-13"> : {{history.Value}}</span>
                </div>
                <div class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="!history.ReadOnly" class="col-12 mx-3 p-0" style="margin-left: 40px !important;">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

            <!--Mode perdu-->
            <ng-container *ngSwitchCase="HistoryMode.LOSE">
              <div class="col mx-3 p-0 q-input-no-border box-rounded q-danger" style="margin-left: 40px !important;">
                <div class="m-1">
                  <p class="history-row history-date">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</p>
                  <span class="history-person">{{history.Person.value}} </span>
                  <span class="font-size-13"> : {{history.Value}}</span>
                </div>
                <div class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="!history.ReadOnly" class="col-12 mx-3 p-0" style="margin-left: 40px !important;">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

            <!--Mode commentaire (hitoriques manuels)-->
            <ng-container *ngSwitchCase="HistoryMode.COMMENT">
              <div class="col mx-3 p-0" style="margin-left: 40px !important;">
                <div class="w-100 q-input-no-border box-rounded">
                  <div class="m-1">
                    <span class="history-date mr-3">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</span>
                    <span class="history-type">
                      <ng-container *ngIf="history.CommentTemplate !== 'UPDATE'">
                        <span class="mr-2" title="Type">{{history.BoTypeText}}</span>
                        <span class="mr-2 q-c-success q-text-s q-pointer" (click)="SetCommentTemplate(history,'UPDATE')"><i class="fas fa-edit"></i></span>
                      </ng-container>
                      <ng-container *ngIf="history.CommentTemplate === 'UPDATE'">
                        <ng-container *ngTemplateOutlet="Update;context:{history:history}"></ng-container>
                      </ng-container>
                    </span>
                    <p class="history-person">{{history.Person.value}}</p>
                    <span class="font-size-13 q-text-backline" [innerHTML]="history.Value"></span>
                  </div>
                </div>
                <ng-container *ngIf="history && history.Responses && history.Responses.length > 0">
                  <ng-container *ngFor="let response of history.Responses">
                    <div class="w-100 mt-1">
                      <div class="p-1 q-input-no-border box-rounded q-light-main q-text-s" style="margin-left: 35px;color: unset !important;">
                        <div class="m-1">
                          <p class="history-row history-date">{{response.Date | NumberOfQueovalDay}} {{response.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{response.Date | NumberOfQueovalYear}} à {{response.Date.heures ? response.Date.heures : '00'}}:{{response.Date.minutes ? response.Date.minutes : '00'}}</p>
                          <p class="history-person">{{response.NamePerson}}</p>
                          <span class="font-size-13" [innerHTML]="response.Value"></span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <div *ngIf="history.CommentTemplate" class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'RESPONSE'">
                    <ng-container *ngTemplateOutlet="Reply;context:{history:history}"></ng-container>
                  </ng-container>
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="col-12 mx-3 p-0 columResponsive" style="margin-left: 40px !important;">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'RESPONSE')">Répondre</span>
                <span *ngIf="!history.ReadOnly" class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <div class="col mx-3 p-0 marginDiv">
                <div class="w-100 q-input-no-border box-rounded">
                  <div class="m-1">
                    <span class="history-date mr-3">{{history.Date | NumberOfQueovalDay}} {{history.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{history.Date | NumberOfQueovalYear}} {{history.Date.heures && history.Date.minutes && history.Date.secondes && history.Date.heures != '00' && history.Date.minutes != '00' && history.Date.secondes != '00' ? 'à ' + (history.Date.heures ? history.Date.heures : '00') + ':' + (history.Date.minutes ? history.Date.minutes : '00') : ''}}</span>
                    <span class="history-type">
                      <ng-container *ngIf="history.CommentTemplate !== 'UPDATE'">
                        <span class="mr-2" title="Type">{{history.BoTypeText}}</span>
                        <span class="mr-2 q-c-success q-text-s q-pointer" (click)="history.CommentTemplate = !history.CommentTemplate || history.CommentTemplate !== 'UPDATE' ? 'UPDATE' : '';"><i class="fas fa-edit"></i></span>
                      </ng-container>
                      <ng-container *ngIf="history.CommentTemplate === 'UPDATE'">
                        <ng-container *ngTemplateOutlet="Update;context:{history:history}"></ng-container>
                      </ng-container>
                    </span>
                    <p class="history-person">{{history.Person.value}}</p>
                    <span class="font-size-13" [innerHTML]="history.Value"></span>
                  </div>
                </div>
                <ng-container *ngIf="history && history.Responses && history.Responses.length > 0">
                  <ng-container *ngFor="let response of history.Responses">
                    <div class="w-100 mt-1">
                      <div class="p-1 q-input-no-border box-rounded q-light-main q-text-s" style="margin-left: 35px;color: unset !important;">
                        <div class="m-1">
                          <p class="history-row history-date">{{response.Date | NumberOfQueovalDay}} {{response.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{response.Date | NumberOfQueovalYear}} à {{response.Date.heures ? response.Date.heures : '00'}}:{{response.Date.minutes ? response.Date.minutes : '00'}}</p>
                          <p class="history-person">{{response.NamePerson}}</p>
                          <span class="font-size-13" [innerHTML]="response.Value"></span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <div *ngIf="history.CommentTemplate" class="w-100">
                  <ng-container *ngIf="history.CommentTemplate === 'RESPONSE'">
                    <ng-container *ngTemplateOutlet="Reply;context:{history:history}"></ng-container>
                  </ng-container>
                  <ng-container *ngIf="history.CommentTemplate === 'DELETE'">
                    <ng-container *ngTemplateOutlet="Delete;context:{history:history}"></ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="col-12 mx-lg-3 m-0 p-0 marginDiv">
                <span class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'RESPONSE')">Répondre</span>
                <span *ngIf="!history.ReadOnly" class="mr-2 q-c-main q-text-s q-pointer" (click)="SetCommentTemplate(history,'DELETE')">Supprimer</span>
              </div>
            </ng-container>

          </div>

        </ng-container>
      </ng-container>

    </div>
  </ng-container>
  <div class="row d-flex" style="justify-content: center;">
    <select class="q-main-select" [(ngModel)]="historyService.pageSize" (ngModelChange)="GetHistory();" style="min-width: 75px;">
      <option *ngFor="let option of historyService.pageSizeOptions" [value]="option">{{option}}</option>
    </select>
    <span class="mx-4" style=" line-height: 35px;">{{(historyService.pageIndex * historyService.pageSize) + 1}} - {{(historyService.pageIndex + 1) * historyService.pageSize > historyService.pageLength ? historyService.pageLength : (historyService.pageIndex + 1) * historyService.pageSize}} sur {{historyService.pageLength}}</span>

    <button [disabled]="historyService.pageIndex == 0" class="q-btn rounded-button q-white" (click)="historyService.pageIndex = 0; GetHistory();">
      <i class="fas fa-angle-double-left"></i>
    </button>
    <button [disabled]="historyService.pageIndex == 0" class="q-btn rounded-button q-white" (click)="historyService.pageIndex = historyService.pageIndex - 1;GetHistory();">
    <i class="fas fa-chevron-left"></i>
    </button>

    <button [disabled]="historyService.pageIndex == GetLastPageIndex()" class="q-btn rounded-button q-white" (click)="historyService.pageIndex = historyService.pageIndex + 1;GetHistory();">
    <i class="fas fa-chevron-right"></i>
    </button>
    <button [disabled]="historyService.pageIndex == GetLastPageIndex()" class="q-btn rounded-button q-white" (click)="historyService.pageIndex = GetLastPageIndex();GetHistory();">
      <i class="fas fa-angle-double-right"></i>
    </button>
  </div>

  <ng-template #Reply let-history="history">
    <div *ngIf="history && history.Id" class="q-input-no-border box-rounded" style="margin-left: 35px;">
      <textarea #TextareaReply class="q-input-no-border noscrollbars" (keyup)="TexteareaAutoGrow($event);" rows="1" placeholder="Ecrire une réponse"></textarea>
      <button *ngIf="!histoIsSaving" class="m-2 px-1 q-text-s col-auto q-btn q-main q-pointer" [disabled]="!TextareaReply.value" (click)="SaveReply(TextareaReply, history)">Enregistrer</button>
      <span *ngIf="!histoIsSaving" class="q-text-s q-c-danger q-pointer" (click)="history.CommentTemplate = ''">Annuler</span>
      <span *ngIf="histoIsSaving" class="q-text-s q-c-main"><i class="fas fa-spin fa-spinner fa-pulse"></i></span>
    </div>
  </ng-template>

  <ng-template #Update let-history="history">
    <ng-container *ngIf="history && history.Id">
      <select class="q-main-select" (change)="UpdateHistory(history, $event.target.value)" required>
        <option *ngFor="let type of history.BoTypes" [value]="type.id" [selected]="type.id === history.BoTypeValue">
          {{type.value}}
        </option>
      </select>
      <!--<span *ngIf="!histoIsSaving" class="m-2 px-1 q-text-s col-auto q-c-success q-pointer" (click)="UpdateHistory(history)"><i class="fas fa-save"></i></span>-->
      <span *ngIf="!histoIsSaving" class="ml-2 q-text-s q-c-danger q-pointer" (click)="history.CommentTemplate = ''"><i class="fas fa-undo-alt"></i></span>
      <span *ngIf="histoIsSaving" class="q-text-s q-c-main"><i class="fas fa-spin fa-spinner fa-pulse"></i></span>
    </ng-container>
  </ng-template>
  <ng-template #Delete let-history="history">
    <div *ngIf="history && history.Id" class="mt-1 px-3 box-rounded" style="border: 1px solid var(--c-main);">
      <span class="q-c-secondary q-text-s col-auto">{{history.Responses && history.Responses.length > 0 ? "Supprimer l'historique et les réponses" : 'Confirmer la suppression'}}</span>
      <button *ngIf="!histoIsSaving && !history.ReadOnly" class="m-2 px-1 q-text-s col-auto q-btn q-main q-pointer" (click)="DeleteHistory(history)">Supprimer</button>
      <span *ngIf="!histoIsSaving" class="q-text-s q-c-danger q-pointer" (click)="history.CommentTemplate = ''">Annuler</span>
      <span *ngIf="histoIsSaving" class="q-text-s q-c-main"><i class="fas fa-spin fa-spinner fa-pulse"></i></span>
    </div>
  </ng-template>
  <ng-template #histoDetailmodal>
    <div class="modalContainer">
      <div class="modal-header">
        <div>
          <p class="history-row history-date">{{selectedHistory.Date | NumberOfQueovalDay}} {{selectedHistory.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{selectedHistory.Date | NumberOfQueovalYear}} {{selectedHistory.Date.heures && selectedHistory.Date.minutes && selectedHistory.Date.secondes && selectedHistory.Date.heures != '00' && selectedHistory.Date.minutes != '00' && selectedHistory.Date.secondes != '00' ? 'à ' + (selectedHistory.Date.heures ? selectedHistory.Date.heures : '00') + ':' + (selectedHistory.Date.minutes ? selectedHistory.Date.minutes : '00') : ''}}</p>
          <strong><i class="fas fa-envelope"></i> {{selectedHistory.Person.value}}</strong>
        </div>
        <button type="button" class="close" (click)="CloseHistoModal()">
          <span aria-hidden="true" class="q-c-danger">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="q-text-m" [innerHTML]="selectedHistory.Value"></p>
        <div class="mb-2" *ngIf="selectedHistory.EtatHisto">
          <span class="q-bold q-text-m">Etat: </span><span class="q-text-m">{{selectedHistory.EtatHisto}}</span>
        </div>
        <div id="mailDetail" [innerHTML]="selectedHistory.Detail" class="modalBody-maildetails"></div>
      </div>
    </div>
  </ng-template>
</div>
